<template>
    <notifications group="default" position="top center">
        <div slot="body" slot-scope="{item}" :class="item.type" class="notification">
            <div class="notification-content">
                <div class="icon" v-if="item.data && item.data.icon">
                    <i :class="`fal fa-${item.data.icon}`">
                    </i>
                </div>
                <div class="info">
                    <h4>{{item.title}}</h4>
                    <p>
                        {{item.text}}
                    </p>
                </div>
            </div>
        </div>
    </notifications>
</template>

<script>
export default {name: 'CustomNotifications'}
</script>

<style scoped lang="scss">
    .notification-wrapper {
        .notification {
            padding: 10px;
            border-radius: 5px;
            margin: 5px;
            background-color: rgba(68, 164, 252, .9);
            font-size: 1.3em;

            &, & * {
                color: #ffffff !important;
            }

            &.warn {
                background: #ffb648;
            }

            &.error {
                background-color: rgba(229, 77, 66, .9);
            }

            &.success {
                background: #68CD86;
            }

            .notification-content {
                display: flex;
                align-items: center;
                justify-content: center;

                .icon {
                    padding: 15px;
                    font-size: 1.5em;
                }

                .info {
                    flex-grow: 1;
                }
            }

            h4, p {
                margin: 0;
                padding: 3px;
                font-size: .8em;
            }
        }
    }
</style>
